import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth()
  const location = useLocation()

  console.log('ProtectedRoute check:', { isAuthenticated, isLoading, path: location.pathname, emailVerified: user?.email_verified })

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-secondary-600 font-medium">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />
  }

  // Require email verification before accessing protected routes
  if (user && !user.email_verified) {
    return <Navigate to="/verify-email" state={{ email: user.email, awaitingVerification: true }} replace />
  }

  return children
}

export default ProtectedRoute